var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.27 1.84839H9.40676V14.1819H16.27V1.84839Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84257 8.01514C9.84149 6.82733 10.1107 5.65484 10.6297 4.58644C11.1487 3.51804 11.904 2.58173 12.8384 1.84838C11.6813 0.938865 10.2916 0.37325 8.82827 0.216185C7.3649 0.0591194 5.88686 0.316937 4.56309 0.96018C3.23931 1.60342 2.12322 2.60614 1.34238 3.8537C0.56154 5.10127 0.147461 6.54336 0.147461 8.01514C0.147461 9.48692 0.56154 10.929 1.34238 12.1766C2.12322 13.4241 3.23931 14.4269 4.56309 15.0701C5.88686 15.7133 7.3649 15.9712 8.82827 15.8141C10.2916 15.657 11.6813 15.0914 12.8384 14.1819C11.904 13.4485 11.1487 12.5122 10.6297 11.4438C10.1107 10.3754 9.8415 9.20294 9.84257 8.01514Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.529 8.01514C25.529 9.48689 25.115 10.929 24.3342 12.1765C23.5534 13.4241 22.4374 14.4268 21.1136 15.0701C19.7899 15.7133 18.3118 15.9712 16.8485 15.8141C15.3851 15.657 13.9955 15.0914 12.8384 14.1819C13.772 13.4478 14.5267 12.5113 15.0457 11.4431C15.5646 10.3749 15.8343 9.20275 15.8343 8.01514C15.8343 6.82752 15.5646 5.6554 15.0457 4.58717C14.5267 3.51893 13.772 2.58247 12.8384 1.84838C13.9955 0.938864 15.3851 0.373246 16.8485 0.216183C18.3118 0.0591193 19.7899 0.316948 21.1136 0.960198C22.4374 1.60345 23.5534 2.60616 24.3342 3.85373C25.115 5.1013 25.529 6.54338 25.529 8.01514Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7807 12.8756V12.6231H24.8825V12.5716H24.6232V12.6231H24.725V12.8756H24.7807ZM25.2841 12.8756V12.5711H25.2046L25.1132 12.7805L25.0217 12.5711H24.9422V12.8756H24.9983V12.6459L25.0841 12.8439H25.1423L25.228 12.6454V12.8756H25.2841Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.0222b31f6465362e2118151e7d7beee4.svg";
export { ForwardRef as ReactComponent };